@if (step().position && step().totalQuestions) {
  <div class="counter ion-margin-bottom">
    {{ step().position }}/{{ step().totalQuestions }}
  </div>
}
